/****************************************************************************
 * Copyright 2021 EPAM Systems
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 ***************************************************************************/
import { Open } from 'components/modal/Open';
import { Save } from 'components/modal/save';
import { Delete } from 'components/modal/Delete';
import { UpdateSequenceInRNABuilder } from 'components/modal/UpdateSequenceInRNABuilder';
import { MonomerConnection } from 'components/modal/monomerConnection';
import { ConfirmationDialog } from 'components/modal/ConfirmationDialog';
import { ModalName } from 'state/modal';

export const modalComponentList: Record<
  ModalName,
  | typeof Open
  | typeof Save
  | typeof Delete
  | typeof UpdateSequenceInRNABuilder
  | typeof MonomerConnection
  | typeof ConfirmationDialog
> = {
  open: Open,
  save: Save,
  delete: Delete,
  updateSequenceInRNABuilder: UpdateSequenceInRNABuilder,
  monomerConnection: MonomerConnection,
  confirmationDialog: ConfirmationDialog,
};
